import React, { memo } from 'react'
import { Box } from '@mui/material'

import FacebookContainer from '../../containers/socialMediaButtons/FacebookContainer'
import GoogleContainer from '../../containers/socialMediaButtons/GoogleContainer'

const SocialMedia = ({ onSocialMediaLogin, restProps }) => {
  return (
    <Box
      sx={{
        gap: 1.5,
        display: 'flex',
        justifyContent: 'center'
      }}
      {...restProps}
    >
      <FacebookContainer onSocialMediaLogin={onSocialMediaLogin} />
      <GoogleContainer onSocialMediaLogin={onSocialMediaLogin} />
    </Box>
  )
}

export default memo(SocialMedia)
